<template>
  <b-card no-body>
    <b-list-group flush>
      <b-list-group-item 
        v-for="(h, index) in onderdeel.acties" 
        :key="index"
      >
        <b-input-group :prepend="h.naam + ' in '">
          <b-input 
            v-model.number="jaren[index]" 
            placeholder="Jaartal"
          />
          <b-input-group-addon>
            <b-button
              @click="
                h.jaren.push({
                  jaar: jaren[index],
                  stuck: true,
                  uitgevoerd: true,
                })
              "
            >
              uitgevoerd
            </b-button>
          </b-input-group-addon>
        </b-input-group>
      </b-list-group-item>
    </b-list-group>
    <b-card-footer>
      De conditie wordt beinvloed door uitgevoerde werkzaamheden.
    </b-card-footer>
  </b-card>
</template>
<script>
export default {
  name: "ChecklistItemTypeD",
  props: {
    onderdeel: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      jaren: [],
    };
  },
  mounted() {

    /*this.onderdeel.acties.foreach(function () {
      this.jaren.push(2020);
    });*/
  },
  methods: {
    toevoegenUitvoering() {
      this.onderdeel.jaar = this.jaar - 10;
    },
  },
};
</script>
